<script lang="ts">
    import Button from "@components/button/Button.svelte"
    import Icon from "@components/material/Icon.svelte"
    import { exitReaderFocus } from "@utils/reading/reader-focus"

    export let exit = exitReaderFocus
</script>

<div class="reader-focus-exit">
    <Button
        class="reader-focus-exit-button"
        color="white"
        go={exit}
        aria-label="Exit fullscreen reading mode"
        title="Exit fullscreen reading mode"
    >
        <Icon icon="maxmin" toggled class="h-5 w-5" />
    </Button>
</div>

<style>
    .reader-focus-exit {
        position: fixed;
        top: calc(var(--safe-area-inset-top, 0rem) + 0.65rem);
        right: max(0.65rem, var(--safe-area-inset-right, 0rem));
        z-index: 21;
        width: 2.75rem;
        height: 2.75rem;
    }

    .reader-focus-exit :global(.reader-focus-exit-button) {
        width: 100%;
        min-width: 0;
        height: 100%;
        min-height: 100%;
        padding: 0;
    }
</style>
